import { Component, Input, OnInit, inject } from '@angular/core';
import { AnnexService } from 'src/app/data/annex.service';
import { PendingAnnexDto } from 'src/app/models/dtos/annexes/pending-annex-dto';

@Component({
  selector: 'app-successfully-signed-annex',
  templateUrl: './successfully-signed-annex.component.html',
  styleUrls: ['./successfully-signed-annex.component.scss'],
  standalone: false,
})
export class SuccessfullySignedAnnexComponent implements OnInit {
  private annexService = inject(AnnexService);

  @Input() workerId: number;
  @Input() annexId: number;
  pendingAnnexes: PendingAnnexDto[] = [];

  ngOnInit(): void {
    this.annexService.getPendingToSign().subscribe({
      next: (list) => (this.pendingAnnexes = list ?? []),
      error: () => (this.pendingAnnexes = []),
    });
  }
}
